// Görseli verilen kenar uzunluğuna sığacak şekilde canvas ile yeniden boyutlandırır ve JPEG blob döner.
// Form seçenek görselleri ve kalıp kapak görselleri arasında paylaşılır.
export async function compressImage(file, maxDimension = 800, quality = 0.75) {
  const dataUrl = await readFileAsDataUrl(file);
  const image = await loadImage(dataUrl);

  // Hedef boyutu en büyük kenara göre orantılı hesapla
  let { width, height } = image;
  if (width > maxDimension || height > maxDimension) {
    if (width >= height) {
      height = Math.round((height * maxDimension) / width);
      width = maxDimension;
    } else {
      width = Math.round((width * maxDimension) / height);
      height = maxDimension;
    }
  }

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const context = canvas.getContext('2d');
  if (!context) {
    throw new Error('Tarayıcı canvas desteklemiyor.');
  }
  // Beyaz arka plan: PNG şeffaflıklarının JPEG'de siyah çıkmasını engeller
  context.fillStyle = '#ffffff';
  context.fillRect(0, 0, width, height);
  context.drawImage(image, 0, 0, width, height);

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error('Görsel sıkıştırılamadı.'));
        return;
      }
      resolve(blob);
    }, 'image/jpeg', quality);
  });
}

function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => resolve(String(event.target?.result || ''));
    reader.onerror = () => reject(new Error('Dosya okunamadı.'));
    reader.readAsDataURL(file);
  });
}

function loadImage(source) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('Görsel yüklenemedi.'));
    image.src = source;
  });
}
